var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-header'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("401 - Access denied")])])
}]

export { render, staticRenderFns }